enum ChatBotType {
    Trimbot = 1,
    GeneralBot = 2,
  }
  
  export default ChatBotType;
